<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">注册用户/商家管理列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1" style="margin-right: 24px">
            <div class="label">用户名</div>
            <label
              ><input type="text" class="cg-input" v-model="username"
            /></label>
          </div>
          <div class="item col-1" style="margin-right: 24px">
            <div class="label">手机号码</div>
            <label
              ><input type="number" class="cg-input" v-model="phone"
            /></label>
          </div>
          <div class="item col-1" style="margin-right: 24px">
            <div class="label">星球码</div>
            <label
              ><input type="number" class="cg-input" v-model="qym"
            /></label>
          </div>
          <div class="item col-1" style="margin-right: 24px">
            <div class="label">版本</div>
            <el-select
              size="mini"
              class="cg-input"
              filterable
              clearable
              v-model="bb"
              placeholder="请选择版本"
              style="padding: 4px 0"
            >
              <el-option
                v-for="item in banben"
                :key="item.id"
                :label="item.name"
                :value="+item.id"
              />
            </el-select>
          </div>
          <el-button
            class="publish-btn"
            style="margin-right: -24px"
            size="small"
            @click="saves"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <el-table
      :data="users"
      border
      height="500px"
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="date" label="注册时间">
        <template #default="scope">
          {{ proxy.$day(scope.row.date).format("YYYY-MM-DD") }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="avatarUrl" label="用户头像">
        <template #default="scope">
          <img
            v-if="scope.row.avatarUrl"
            :src="getFullImgUrl(scope.row.avatarUrl)"
            alt=""
            style="width: 45px; height: 45px; border-radius: 50%"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="nickName" label="用户名">
        <template #default="scope">
          {{
            scope.row.nickName == "" ? scope.row.bindCode : scope.row.nickName
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="手机号码" />
      <el-table-column align="center" prop="bindCode" label="星球码" />
      <el-table-column align="center" prop="versionName" label="版本" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="users.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label">用户id</span>
          <label
            ><input
              type="text"
              class="cg-input"
              v-model="upid"
              :disabled="true"
          /></label>
        </div>
        <div class="item">
          <span class="label" require>版本</span>
          <el-select
            size="mini"
            class="cg-input"
            filterable
            v-model="upbb"
            placeholder="请选择版本"
            style="padding: 4px 0"
          >
            <el-option
              v-for="item in banben"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            />
          </el-select>
        </div>
        <div class="footer">
          <el-button class="publish-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

//弹窗字段
const upbb = ref("");
const upid = ref("");
const username = ref(""); // 用户名
const qym = ref(""); //星球码
const banben = ref([
  { id: 0, name: "注册版" },
  { id: 1, name: "商家1号版" },
  { id: 2, name: "商家2号版" },
]);
const bb = ref("");
const phone = ref("");
const dialogTableVisible = ref(false); //弹窗控制
const users = ref([]); //列表

// 分页变量（统一）
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

const save = async () => {
  const sendata = {
    id: upid.value, //用户id
    version: upbb.value, //版本
  };
  console.log(sendata, "传的参数对不对");
  const res = await proxy.$api.System.MemberVersion.update(sendata);
  if (res.data.code == 200) {
    dialogTableVisible.value = false;
    proxy.$message.success("修改成功");
    pages.value.page = 1;
    noMore.value = false;
    users.value = [];
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
};

const saves = async () => {
  pages.value.page = 1;
  noMore.value = false;
  users.value = [];
  getList();
};

const loadMore = async () => {
  await getList(true);
};

const up = (row) => {
  console.log(row, "拿到的是不是当行数据");
  upbb.value = row.version;
  upid.value = row.id;
  dialogTableVisible.value = true;
};

// 缓存值
const STORAGE_KEY = "member-list";

// 监听查询条件
watch([username, qym, phone, bb], () => {
  const searchParams = {
    username: username.value,
    qym: qym.value,
    phone: phone.value,
    bb: bb.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      bb.value = cache.bb ?? "";
      qym.value = cache.qym ?? "";
      username.value = cache.username ?? "";
      phone.value = cache.phone ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    nickName: username.value,
    bindCode: qym.value,
    phone: phone.value,
    version: bb.value,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Operation.MemberList.get(sendata);
    console.log(res.data.code);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        users.value = currentData;
      } else {
        users.value = [...users.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? users.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      proxy.$message.error("网络错误");
      users.value = [];
    }
  } catch (e) {
    if (!isLoadMore) {
      proxy.$message.error("网络错误");
      users.value = [];
    }
  } finally {
    loading.value = false;
  }
};

const getFullImgUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};

const delUser = async (id) => {
  const sendata = { id: id };
  const res = await proxy.$api.Operation.MemberList.del(sendata);
  if (res.data.code == 200) {
    proxy.$message.success("删除成功");
    pages.value.page = 1;
    noMore.value = false;
    users.value = [];
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
  console.log(id);
};

onMounted(() => {
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./member-list.scss";
.panel-title {
  color: #999;
}
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}

.publish-btn {
  background-color: #ff9900;
}
</style>
